import ReactDOM from 'react-dom';

const PortalProvider = ({
    children,
    elementId
}) => {
    if (document.getElementById(elementId)) {
        return ReactDOM.createPortal(children, document.getElementById(elementId));
    }

    return null;
};

export default PortalProvider;